import axios from "axios";

import { ENDPOINT } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { isValidJWT } from "../../utils/authentication/isValidJWT";

export async function planTripDetails(
  accessJWT: string,
  controller: any,
  messages: any[],
  iteneryInput: any,
) {
  const URL = `${ENDPOINT}/app/v1/itineraries/search`;
  let config = getHeaderConfig(controller.signal, accessJWT);
  let body = {
    userInput: null,
    messages,
    iteneryInput,
  };
  if (!accessJWT || !isValidJWT(accessJWT)) return null;
  try {
    const response = await axios.post(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      consoleLog(["PLAN TRIP DETAILS RESPONSE", JSON.parse(decryptedData)]);
      return decryptedData ? JSON.parse(decryptedData) : null;
    }
    return null;
  } catch (error) {
    consoleLog(["PLAN TRIP DETAILS ERROR", error]);
    return null;
  }
}
